export default "__VITE_ASSET__DEbCeQd8__"